import { takeLatest, put } from "redux-saga/effects";
import { ApiCall } from "../api";
import {
  ANT_SOLICITAR_START,
  ANT_GETLISTADO_COMPLETE,
  ANT_GETLISTADO_START,
  NOT_LOADING_COMPLETE,
  NSB_MENSAJE_ADD,
} from "../../const/actionTypes";
// import { addMinutes } from "date-fns";
import { jwtDecode } from "jwt-decode";

export function* GetAnticipos({ payload }) {
  const p = {
    ...payload,
  };
  const token = {
    ...jwtDecode(p.Token),
  };
  if (
    token &&
    token.conductor &&
    token.conductor.toString() === p.Conductor.toString()
    // && (!nbf || (nbf && nbf >= addMinutes(new Date(), -3)))
  ) {
    yield put({ type: NOT_LOADING_COMPLETE, payload: true });
    const ants = yield ApiCall(
      "/api/Anticipos/ObtenerAnticipos",
      "POST",
      JSON.stringify({
        Conductor: p.Conductor,
        Token: p.Token,
      }),
      p.Token
    );
    yield put({
      type: ANT_GETLISTADO_COMPLETE,
      payload: (ants && ants.Results) || [],
    });

    yield put({ type: NOT_LOADING_COMPLETE, payload: false });
  }
}
export function* Solicitar({ payload }) {
  yield put({ type: NOT_LOADING_COMPLETE, payload: true });

  const p = {
    ...payload,
  };
  const token = {
    ...jwtDecode(p.Token),
  };
  if (
    token &&
    token.conductor &&
    token.conductor.toString() === p.Conductor.toString()
    // && (!nbf || (nbf && nbf >= addMinutes(new Date(), -3)))
  ) {
    const res = yield ApiCall(
      "/api/Anticipos/Solicitar",
      "POST",
      JSON.stringify(p),
      p.Token
    );
    let mensaje;
    if (res && !res.Error) {
      mensaje = {
        mensaje: "Solicitud realizada con éxito.",
        variant: "success",
      };
      yield GetAnticipos({
        payload: p,
      });
    } else {
      mensaje = {
        mensaje:
          "Hubo un error al realizar la solicitud.\nIntente nuevamente mas tarde.",
        variant: "error",
      };
    }
    yield put({ type: NOT_LOADING_COMPLETE, payload: false });
    yield put({ type: NSB_MENSAJE_ADD, payload: mensaje });
  }
}

export default function* anticipos() {
  yield takeLatest(ANT_GETLISTADO_START, GetAnticipos);
  yield takeLatest(ANT_SOLICITAR_START, Solicitar);
}
